const mednowCommons = window.mednowCommons || {};

mednowCommons.getRegionName = async function () {
	const storeLocation = ['Ontario', 'British Columbia'];
	const provinceUnderON = [
		'Ontario',
		'Manitoba',
		'Nova Scotia',
		'New Brunswick',
		'Newfoundland and Labrador',
		'Prince Edward Island',
	];
	const provinceUnderBC = [
		'Alberta',
		'Northwest territories',
		'Yukon',
		'Saskatchewan',
		'Nunavut',
		'British Columbia',
	];

	const regionData = await mednowCommons.fetchRegionDetails();

	const regionName = regionData.region_name;

	console.log(regionData, '__regionDATA');

	if (provinceUnderON.includes(regionName)) {
		return storeLocation[0];
	} else if (provinceUnderBC.includes(regionName)) {
		return storeLocation[1];
	} else {
		return storeLocation[0];
	}
};

mednowCommons.fetchRegionDetails = async function () {
	return await fetch(
		'https://api.ipstack.com/check?access_key=05c0208d826c2765485f46e82ada9bd4'
	).then((response) => response.json());
};

document.addEventListener('alpine:init', () => {
	// Location
	Alpine.store('location', {
		city: Alpine.$persist(null).as('location_city'),
		prevCity: Alpine.$persist('Ontario').as('location_prev_city'),
		setCity(city) {
			window.localStorage.setItem(
				'location_prev_city',
				window.localStorage.getItem('location_city')
			);
			this.city = city;
			window.localStorage.setItem('location_city', JSON.stringify(city));
			document
				.querySelector('[x-ref=location_popup]')
				.removeAttribute('open');

			fetch('/cart/clear').then(() => {
				if (this.city === 'Quebec') {
					setTimeout(() => {
						window.location.href = '/fr/pages/home-quebec';
					}, 1000);
				} else {
					setTimeout(() => {
						window.location.reload();
					}, 1000);
				}
			});
		},
		async init() {
			// if (!window.localStorage.getItem('location_city')) {
				this.city = await mednowCommons.getRegionName();
			// }
			const currentPathName = window.location.href;
			if (
				JSON.parse(window.localStorage.getItem('location_city')) ===
					'Quebec' &&
				!document.body.classList.contains('region__quebec')
			) {
				if (this.prevCity) {
					const pCity = JSON.parse(
						window.localStorage.getItem('location_prev_city')
					);
					this.city = pCity;
					window.localStorage.setItem(
						'location_city',
						JSON.stringify(pCity)
					);
				} else {
					this.city = await mednowCommons.getRegionName();
				}
			}
		},
	});

	Alpine.data('HostWarning', () => ({
		currentRegion: null,
		showWarning: false,
		init() {
			this.currentRegion = Alpine.store('location').city;
			this.show();
		},
		async show() {
			const region_details = await mednowCommons.fetchRegionDetails();
			const region_name = region_details?.region_name;

			console.log(region_name);
			if (region_name == 'Quebec') {
				this.showWarning = true;
				return;
			}

			this.showWarning = false;
		},
		redirect() {
			Alpine.store('location').city = 'Quebec';
			window.location.href = '/fr/pages/home-quebec';
		},
	}));
});
